import Cookie from 'js-cookie';

import AuthApi from '../../apis/auth';
import { VALIDATE_USER, SHOW_TOAST, HIDE_TOAST } from '../../types';
import { getProfile } from '../aeMyProfile';
import { showToast } from '../toast';

import { setCookieByUserData, setCurrentUserToCookie } from '../../../utils/cookie';
import { isEmpty, validateRole } from '../../../utils/generic';

import { signOutSuccess } from './signout';

import { ERROR_MSG, ERROR_MSG_401 } from '../../../constants';

export const validateUserByCookie =
  (ctx = {}) =>
  (dispatch, getState) => {
    const state = getState();
    let cookies = {};

    if (ctx.req) {
      cookies = ctx.req.cookies;
    } else {
      cookies['access-token'] = Cookie.get('access-token');
    }

    if (state.currentUser.data || cookies.currentUser || !cookies['access-token']) {
      return;
    }

    const callApi = async () => {
      try {
        const res = await AuthApi.validate(cookies);

        if (res.status === 500) {
          throw res;
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          const user = res_data.data.user;

          if (!validateRole(user)) {
            if (ctx.res) {
              ctx.res.clearCookie('access-token');
              ctx.res.clearCookie('client');
              ctx.res.clearCookie('uid');
            } else {
              dispatch(signOutSuccess);
            }

            const error = { message: `You don't have required role.` };

            throw error;
          } else {
            const data = { cookies: { ...res_data.data.headers } };

            setCurrentUserToCookie(res_data, ctx);
            dispatch({ type: `${VALIDATE_USER}_success`, payload: res_data });
            await dispatch(getProfile(data));
          }
        }
      } catch (err) {
        dispatch(signInFailed(err));
      }
    };

    dispatch({ type: `${VALIDATE_USER}_started` });

    return Promise.resolve(callApi());
  };

export const signInSuccess = (res_data, req_data) => (dispatch) => {
  const user = res_data.data.user;
  const resHeaders = res_data.data.headers;
  const res_uid = resHeaders.uid;
  const req_uid = req_data.email || (req_data.omniauth && req_data.omniauth.uid);

  if (req_uid?.toLowerCase() !== res_uid?.toLowerCase()) {
    const error = { message: `You have invalid user id` };

    throw error;
  }

  if (!validateRole(user)) {
    const error = { message: `You don't have required role.` };

    throw error;
  }

  setCookieByUserData(res_data);
  dispatch({ type: `${VALIDATE_USER}_success`, payload: res_data });
  dispatch(getProfile());
};

export const signInFailed = (err) => (dispatch) => {
  dispatch({ type: `${VALIDATE_USER}_failed`, payload: err });
  dispatch({
    type: `${SHOW_TOAST}`,
    payload: { type: 'error', message: err.message || 'Failed to SignIn' }
  });
};

export const googleSignUp = (profile) => (dispatch, getState) => {
  const state = getState();

  if (state.currentUser.data) {
    return;
  }

  const callApi = async () => {
    try {
      const res = await AuthApi.googleSignUp(profile);

      if (res.status === 500) {
        throw res;
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      } else {
        dispatch(signInSuccess(res_data, profile));
      }
    } catch (err) {
      dispatch(signInFailed(err));
    }
  };

  dispatch({ type: `${VALIDATE_USER}_started` });

  return Promise.resolve(callApi());
};

export const awignSignIn = (data) => async (dispatch, getState) => {
  const state = getState();

  if (state.currentUser.data) {
    return;
  }

  const callApi = async () => {
    try {
      const res = await AuthApi.awignSignIn(data);

      if (res.status === 500) {
        throw res;
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      } else {
        dispatch(signInSuccess(res_data, data.user));
      }
    } catch (err) {
      dispatch({ type: `${VALIDATE_USER}_failed`, payload: err });
    }
  };

  dispatch({ type: `${HIDE_TOAST}` });
  dispatch({ type: `${VALIDATE_USER}_started` });

  return Promise.resolve(callApi());
};

export const setUser = (ctx) => async (dispatch, getState) => {
  const state = getState();

  if (state.currentUser.data) {
    return;
  }

  if (isEmpty(ctx.req.cookies['access-token'])) {
    return;
  }

  const callApi = async () => {
    try {
      const res = await AuthApi.validateToken(ctx.req);

      if (res.status === 500) {
        throw res;
      }

      const res_data = await res.json();

      if (res.status === 401) {
        if (ctx.res) {
          ctx.res.clearCookie('access-token', { path: process.env.DOMAIN });
        }

        dispatch(showToast('error', ERROR_MSG_401));
        dispatch(signOut());
      }

      if (!res.ok) {
        throw res_data;
      } else {
        dispatch({ type: `${VALIDATE_USER}_success`, payload: ctx.req.cookies['access-token'] });
      }
    } catch (err) {
      const payload = err && err.message ? err : { message: ERROR_MSG };

      dispatch({ type: `${VALIDATE_USER}_failed`, payload: payload });
    }
  };

  dispatch({ type: `${HIDE_TOAST}` });
  dispatch({ type: `${VALIDATE_USER}_started` });

  return Promise.resolve(callApi());
};

export const signOut = () => async (dispatch, getState) => {
  dispatch({ type: `${VALIDATE_USER}_started` });
  try {
    const user = getState().currentUser.data;

    if (!user) {
      return dispatch(signOutSuccess);
    }

    return dispatch(signOutSuccess);
  } catch (err) {
    dispatch({
      type: `${VALIDATE_USER}_failed`,
      payload: 'Something went wrong, Unable to log out.'
    });
    dispatch({
      type: `${SHOW_TOAST}`,
      payload: { type: 'error', message: err.message || 'Something went wrong, Unable to log out.' }
    });

    return Promise.reject(err);
  }
};
